import { DbNode } from './DbNode/DbNode';
import { GSheetNode } from './GSheetNode/GSheetNode';
import { RestApiNode } from './RestApiNode/RestApiNode';

export const Components = {
  dbNode: DbNode,
  restApiNode: RestApiNode,
  gSheetNode: GSheetNode,
};
